const allowedUserIds = [
  "2D9BFUVY",
  "MN34OP56",
  "OP12QR34",
  "C8J1P6DR",
  "WSORODTJ",
  "OKSWae1L",
  "YB8kvHdr",
  "YtFcB5Bn",
  "ODJS9L7Q",
  "5DOLKBD0",
  "yDTJaiPD",
  "MJFMVAA0",
  "UFTBN1O1",
  "REj7Rzf1",
  "5NVWZUY0",
  "G7G6F7N8",
];

export default allowedUserIds;
